var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-btn"},[_c('v-btn',{staticClass:"mt-6 base-body-text text-capitalize",class:{
      'base-submit-button': !_vm.disable,
      'base-disable-button': _vm.disable
    },attrs:{"disabled":_vm.disable,"loading":_vm.get_auth_loading,"type":"submit"}},[_vm._v(" "+_vm._s(_vm.btn_text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }